import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import searchIcon from "../../../../assets/VZY/mobile-search-icon.svg";
import closeIcon from "../../../../assets/VZY/close.svg";
import { useNavigate } from "react-router-dom";
import NoResultsfound from "../../../../assets/VZY/No_Results_found.svg";
import { FeedBackModal } from "../../components/HelpfulFeedback/FeedbackModal";
export const SearchBox = () => {
  const [showFeedback, setShowFeedback] = useState(false);
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [topSearches, setTopSearches] = useState([]);
  const [showList, setShowList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const formatCategoryForUrl = useCallback((value = "") => {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }, []);

  const fetchSearchResults = useCallback(
    async (searchText) => {
      if (searchText.length < 3) {
        setSuggestions([]);
        return;
      }

      try {
        setLoading(true);
        setError("");

        const response = await axios.get(
          `${apiBaseURL}/api/VZYHelpSupport/search`,
          {
            params: {
              q: searchText,
              language: "en",
              limit: 5,
            },
          },
        );

        const list = response?.data?.result?.data?.suggestions ?? [];
        setSuggestions(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Search API error:", err);
        setError("Unable to fetch results");
        setSuggestions([]);
      } finally {
        setLoading(false);
      }
    },
    [apiBaseURL],
  );
  useEffect(() => {
    if (showList && query.length >= 3) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showList, query]);

  const fetchTopSearches = useCallback(async () => {
    try {
      const payload = {
        contentCode: "",
        contentTypeID: 0,
        categoryID: 0,
        isActive: 1,
        pageNumber: 1,
        pageSize: 10,
        searchValue: "",
        CategoryIDs: [],
      };

      const response = await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/FetchTopSearch`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      const list = response?.data?.result?.fAQs ?? [];
      setTopSearches(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Top Search API error:", err);
      setTopSearches([]);
    }
  }, [apiBaseURL]);

  useEffect(() => {
    fetchTopSearches();
  }, [fetchTopSearches]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (query.length >= 3) {
        fetchSearchResults(query);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [query, fetchSearchResults]);

  const handleSelect = async (item) => {
    setQuery(item.text);
    setShowList(false);

    try {
      const clickPayload = {
        content_id: item?.content_id,
        content_code: item?.content_code,
        content_type_code: item?.type?.toUpperCase(),
        position: 0,
        query: item?.text,
        session_id: "",
        search_id: item?.content_id,
      };

      await axios.post(
        `${apiBaseURL}/api/VZYHelpSupport/GetSearchClickEvent`,
        clickPayload,
        {
          headers: { "Content-Type": "application/json" },
        },
      );
    } catch (error) {
      console.error("Click event failed", error);
    }

    const formattedCategory = formatCategoryForUrl(item?.text);

    if (item?.type === "fq") {
      const payload = {
        contentID: item?.content_id,
        contentCode: item?.content_code,
        contentTitle: item?.text,
        contentTypeID: 1,
        IsSearch: 1,
      };
      navigate(`/VZYSupport/details/${formattedCategory || "notFound"}`, {
        state: {
          detailsIDs: payload,
        },
      });
    }

    if (item?.type === "vt") {
      const payload = {
        contentID: item?.content_id,
        contentCode: item?.content_code,
        contentTitle: item?.text,
        contentTypeID: 2,
        IsSearch: 1,
      };
      navigate(`/VZYSupport/video/${formattedCategory || "notFound"}`, {
        state: {
          detailsIDs: payload,
        },
      });
    }

    if (item?.type === "pt") {
      const payload = {
        contentID: item?.content_id,
        contentCode: item?.content_code,
        contentTitle: item?.text,
        contentTypeID: 3,
        IsSearch: 1,
      };
      navigate(
        `/VZYSupport/PopularTopicsdetails/${formattedCategory || "notFound"}`,
        {
          state: {
            detailsIDs: payload,
          },
        },
      );
    }
  };

  const handleTopSearchClick = (item) => {
    const normalizedItem = {
      text: item?.contentTitle,
      content_id: item?.contentID,
      content_code: item?.contentCode,
      type: item?.type,
    };

    handleSelect(normalizedItem);
  };

  const clearSearch = () => {
    setQuery("");
    setSuggestions([]);
    setShowList(false);
  };

  const truncateText = (text = "", maxLength = 12) => {
    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength)}...`;
  };

  const handleEnterSearch = (e) => {
    if (e.key !== "Enter") return;

    const trimmedQuery = query.trim();
    if (!trimmedQuery) return;
    setShowList(false);
    const payload = {
      searchValue: trimmedQuery,
      IsSearch: 1,
    };

    if (!Array.isArray(suggestions) || suggestions.length === 0) {
      navigate("/VZYSupport/NoResultsFound", {
        state: {
          detailsIDs: payload,
        },
      });
      return;
    }

    navigate("/VZYSupport/SearchList", {
      state: {
        detailsIDs: payload,
      },
    });
  };

  return (
    <>
      <div className="search-box">
        <span className="search-icon">
          <img src={searchIcon} alt="Search" />
        </span>

        <input
          type="text"
          className="search-input"
          maxLength={150}
          placeholder="Search queries or error code"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setShowList(true);
          }}
          onKeyDown={handleEnterSearch}
          onFocus={() => query && setShowList(true)}
          onBlur={() => setTimeout(() => setShowList(false), 500)}
        />

        {query && (
          <span className="clear-icon" onClick={clearSearch}>
            <img src={closeIcon} alt="Close" />
          </span>
        )}
      </div>

      {!query && topSearches.length > 0 && (
        <div className="top-search-items">
          <p className="top-search-title">Top Searches:</p>
          <ul>
            {topSearches.map((item) => (
              <li
                key={item.contentCode}
                onClick={() => handleTopSearchClick(item)}
                title={item?.contentTitle}
              >
                {truncateText(item?.contentTitle, 12)}
              </li>
            ))}
          </ul>
        </div>
      )}

      {showList && query.length >= 3 && (
        <ul className="suggestion-list">
          {loading && <li className="loading">Searching...</li>}

          {!loading && error && <li className="error-text">{error}</li>}

          {!loading && !error && suggestions.length === 0 && (
            <li>
              <div className="no-result-found-box-search">
                <h4>No Results found !</h4>
                <img src={NoResultsfound} alt="No Results found !" />
                <p>Cannot find a solution ?</p>
                <button
                  className="raise-ticket-btn"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    setShowFeedback(true);
                  }}
                >
                  Raise a ticket
                </button>
              </div>
            </li>
          )}

          {!loading &&
            suggestions.map((item) => (
              <li
                key={item.content_id}
                onClick={() => handleSelect(item)}
                dangerouslySetInnerHTML={{
                  __html: item.highlight || item.text,
                }}
              />
            ))}
        </ul>
      )}

      {showList && query.length > 0 && query.length < 3 && (
        <ul className="suggestion-list">
          <li className="info-text">Please enter at least 3 characters</li>
        </ul>
      )}

      <FeedBackModal
        isOpen={showFeedback}
        onClose={() => setShowFeedback(false)}
      />
    </>
  );
};
